// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"vendors-node_modules_glightbox_dist_js_glightbox_min_js":"c9a16bd86d2d3fb34219","src_js_components_ui_Glightbox_ts":"248b3bf64a572fb7d59c","lazysizes":"60db7c3bdc5ad6a2f6e8"}[chunkId] + ".js";
};